export default __webpack_public_path__ + "static/media/vertical.4e5f97a1.svg";